<template>
    <!-- remove the if condition in Appfooter when app is ready staging -->
    <div id="app">
        <notifications group="success_notification"/>

        <AppHeader/>

        <router-view/>

        <AppFooter  />

        <scroll-to-top-button />

        <BrandCentre v-if="showToolBar" />

        <ConfirmDialog></ConfirmDialog>
    </div>
</template>

<script>
    import AppHeader from './components/layout/AppHeader.vue';
    import AppFooter from './components/layout/AppFooter.vue';
    import ScrollToTopButton from "@/components/ui/ScrollToTopButton";
    import planMixin from "./mixins/planMixin";
    import BrandCentre from "@/components/blocks/BrandCentre";
    import ConfirmDialog from 'primevue/confirmdialog';

    export default {
        name: 'App',
        metaInfo: {
            title: 'Khonsu - Home'
        },
        components: {
            BrandCentre,
            ScrollToTopButton,
            AppHeader,
            AppFooter,
            ConfirmDialog
        },
        computed: {
            isIdle() {
                return this.$store.state.idleVue.isIdle;
            },
            userplanname: function () {
                return planMixin.methods.userplan_name();
            },
            userplanstatus: function () {
                return planMixin.methods.userplan_status();
            }
        },
        data() {
            return {
                showToolBar: false,
            }
        },
        created() {
            this.$crontab.addJob({
                name: 'checkUserInactiveStatus',
                interval: {
                    seconds: '/10',
                },
                job: this.checkUserInactiveStatus
            })
        },
        mounted() {
            this.toolbarDisplayHandler(this.$route.path);
        },
        methods: {
            checkUserInactiveStatus: function () {
                if ((sessionStorage.getItem('_khonsu_user_plan_name') === 'Khonsu Light') && (sessionStorage.getItem('_khonsu_user_plan_search_count') == '0')) {
                    if (sessionStorage.getItem("_khonsu_user_plan_status") === 'active') {
                        window.location.href = "/my-account";
                        sessionStorage.setItem("_khonsu_user_plan_status", 'inactive');
                    }
                }
            },
            toolbarDisplayHandler(path) {
                if (path === '/brand-creator' || path === '/brand-creator/' || path === '/brand-checker' || path === '/brand-checker/') {
                    this.showToolBar = true;
                } else {
                    this.showToolBar = false;
                }
            }
        },
        watch: {
            //Handle Khonsu Single Sessiom
            //**********************/
            isIdle: function (newVal) {
                if (newVal) { //is true
                    if (planMixin.methods.userplan_name() === 'Khonsu Single Session') {
                        planMixin.methods.userplan_deactivate('Khonsu Single Session', sessionStorage.getItem('user_id'))
                    }
                }
            },
            userplanstatus: function (newVal) {
                if (newVal === 'inactive') {
                    this.$router.push({path: '/my-account'});
                }
            },
            //**********************/
            $route: function(to){
                this.toolbarDisplayHandler(to.path);
            },
        }
    }
</script>

<style lang="scss">
    @import "assets/styles/scss/base/reset";
    @import 'assets/styles/scss/vendor-extensions/bootstrap';
    @import 'assets/styles/scss/vendors/bootstrap';
    @import "assets/styles/scss/base/typography";
    @import "assets/styles/scss/layout/blocks";
    @import "assets/styles/scss/ui/buttons";
    @import "assets/styles/scss/layout/forms";
    @import "assets/styles/scss/layout/layout";
    @import "assets/styles/scss/base/base";

    @import "assets/styles/scss/utilities/transition";

    //UI
    @import "assets/styles/scss/ui/tabs";
    @import "assets/styles/scss/ui/notifications";
    @import "assets/styles/scss/ui/scroll-to-top-button";
    @import "assets/styles/scss/ui/tooltip";
    @import "assets/styles/scss/ui/drag-drop-input";
    @import "assets/styles/scss/ui/confirmation";
    @import "assets/styles/scss/ui/paginator";
    @import "assets/styles/scss/ui/loading-icon";

    //layout
    @import "assets/styles/scss/layout/header";
    @import "assets/styles/scss/layout/footer";
    @import "assets/styles/scss/layout/get-started";
    @import "assets/styles/scss/layout/app-hero";
    @import "assets/styles/scss/layout/brand-tool";
    @import "assets/styles/scss/layout/accordion";

    //pages
    @import "assets/styles/scss/pages/home";
    @import "assets/styles/scss/pages/login";
    @import "assets/styles/scss/pages/join";
    @import "assets/styles/scss/pages/contact";
    @import "assets/styles/scss/pages/about";
    @import "assets/styles/scss/pages/brand-konstruktor";
    @import "assets/styles/scss/pages/brand-dekonstruktor";
    @import "assets/styles/scss/pages/brand-tester";
    @import "assets/styles/scss/pages/settings";
    @import "assets/styles/scss/pages/top-up";
    @import "assets/styles/scss/pages/reset-password";
    @import "assets/styles/scss/pages/activate-account";
    @import "assets/styles/scss/pages/checkout";
    @import "assets/styles/scss/pages/brand-creator";
    @import "assets/styles/scss/pages/brand-checker";

    //blocks
    @import "assets/styles/scss/blocks/text-block";
    @import "assets/styles/scss/blocks/review-block";
    @import "assets/styles/scss/blocks/how-block";
    @import "assets/styles/scss/blocks/tips-tricks-block";
    @import "assets/styles/scss/blocks/packages-block";
    @import "assets/styles/scss/blocks/tool-block";
    @import "assets/styles/scss/blocks/history-block";
    @import "assets/styles/scss/blocks/product-block";
    @import "assets/styles/scss/blocks/tips-tricks-modal";
    @import "assets/styles/scss/blocks/creator-search-options";
    @import "assets/styles/scss/blocks/creator-search-results";
    @import "assets/styles/scss/blocks/trademark-finder";
    @import "assets/styles/scss/blocks/checker-search-options";
    @import "assets/styles/scss/blocks/checker-search-results";
    @import "assets/styles/scss/blocks/brand-centre";
    @import "assets/styles/scss/blocks/checker-export-options";
    @import "assets/styles/scss/blocks/loading-progress";

    //sections
    @import "assets/styles/scss/sections/call-to-action";
    @import "assets/styles/scss/sections/how-it-works";
    @import "assets/styles/scss/sections/tool-overview";
    @import "assets/styles/scss/sections/trusted-by";
    @import "assets/styles/scss/sections/reviews";
    @import "assets/styles/scss/sections/tips-tricks";
    @import "assets/styles/scss/sections/home-hero";
    @import "assets/styles/scss/sections/our-story-banner";
    @import "assets/styles/scss/sections/khonsu-team";
    @import "assets/styles/scss/sections/our-packages";
    @import "assets/styles/scss/sections/our-products";
    @import "assets/styles/scss/sections/dekonstrukt-description";
    @import "assets/styles/scss/sections/your-plan";
    @import "assets/styles/scss/sections/account-tools";
    @import "assets/styles/scss/sections/history";
    @import "assets/styles/scss/sections/account-activity";
    @import "assets/styles/scss/sections/not-found-hero";
    @import "assets/styles/scss/sections/forgotten-password";
    @import "assets/styles/scss/sections/plans";
    @import "assets/styles/scss/sections/chosen-plan";
    @import "assets/styles/scss/sections/settings-section";


    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*background-color: #e7e7e7;*/
    }
</style>
